import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import axios from "axios";
import Cookies from "js-cookie";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {BlockUI} from "primereact/blockui";

import FormLocker from "../../util/FormLocker";

const HelpFormComponent = (props) => {
  const {t} = props;
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);
  const [types, setTypes] = useState([]);
  const [fields, setFields] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const [levels, setLevels] = useState([]);
  const [positions, setPositions] = useState([]);
  const [messageHu, setMessageHu] = useState('');
  const [messageEn, setMessageEn] = useState('');


  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/help-badge/" + formData.id,
        {
          ...newFormData,
          ...(formData.type === 'ON_SITE' ? {"position": formData.position || "TOP_OF_THE_PAGE"} : {}),
          "message_hu": messageHu,
          "message_en": messageEn,
        },
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          window.App.forceUpdate()
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderHelpList: Math.random(),
            selectedHelpId: response.data.data.id
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarHelpForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow(
            'error',
            t('error'),
            error?.response?.data?.message,
            '',
            (
              Array.isArray(error?.response?.data?.data?.errors?.message)
              && error.response.data.data.errors.message.length > 0
            )
              ? {
                ...error.response,
                data: {
                  ...error.response.data,
                  data: {
                    ...error.response.data.data,
                    errors: {
                      ...Object.keys(error.response.data.data.errors).reduce((acc, key) => (
                        key === 'message' ? acc : {...acc, [key]: error.response.data.data.errors[key]}
                      ), {}),
                      ...(error.response.data.data.errors.message[0]
                        ? {messageHu: [error.response.data.data.errors.message[0]]}
                        : {}),
                      ...(error.response.data.data.errors.message[0]
                        ? {messageEn: [error.response.data.data.errors.message[0]]}
                        : {}),
                    },
                  },
                },
              }
              : error?.response
          )
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/help-badge",
        {
          ...formData,
          ...(formData.type === 'ON_SITE' ? {"position": formData.position || "TOP_OF_THE_PAGE"} : {}),
          "message_hu": messageHu,
          "message_en": messageEn,
        },
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          window.App.forceUpdate()
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderHelpList: Math.random(),
            selectedHelpId: response.data.data.id
          })
          if (props.closeForm === true) {
            window.App.setState({
              sidebarHelpForm: false,
            })
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow(
            'error',
            t('error'),
            error?.response?.data?.message,
            '',
            (
              Array.isArray(error?.response?.data?.data?.errors?.message)
              && error.response.data.data.errors.message.length > 0
            )
              ? {
                ...error.response,
                data: {
                  ...error.response.data,
                  data: {
                    ...error.response.data.data,
                    errors: {
                      ...Object.keys(error.response.data.data.errors).reduce((acc, key) => (
                        key === 'message' ? acc : {...acc, [key]: error.response.data.data.errors[key]}
                      ), {}),
                      ...(error.response.data.data.errors.message[0]
                        ? {messageHu: [error.response.data.data.errors.message[0]]}
                        : {}),
                      ...(error.response.data.data.errors.message[0]
                        ? {messageEn: [error.response.data.data.errors.message[0]]}
                        : {}),
                    },
                  },
                },
              }
              : error?.response
          )
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const Fields = (url) => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/help-badge-form-field?url=" + url,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        let _fields = []
        if (response.data && response.data.data) {
          let _field = response.data.data[url.replace('/', '')]
          if (_field !== undefined) {
            response.data.data[url.replace('/', '')].map((field, index) => {
              _fields.push({
                name: field,
                key: field
              })
            })
          }
        }
        if (_fields && _fields[0]) {
          setFields(_fields);
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

useEffect(() => {
  if (formData) {
    const currentLanguage = (props?.i18n?.language || Cookies.get("language") || '').toLowerCase();
    const translatedEn = formData?.translated_values?.en?.message;
    const translatedHu = formData?.translated_values?.hu?.message;
    if (currentLanguage.startsWith('hu')) {
      if (formData.message !== undefined && formData.message !== null) {
        setMessageHu(formData.message)
      } else if (translatedHu !== undefined && translatedHu !== null) {
        setMessageHu(translatedHu)
      }
      if (translatedEn !== undefined && translatedEn !== null) {
        setMessageEn(translatedEn)
      }
    } else {
      if (formData.message !== undefined && formData.message !== null) {
        setMessageEn(formData.message)
      } else if (translatedEn !== undefined && translatedEn !== null) {
        setMessageEn(translatedEn)
      }
      if (translatedHu !== undefined && translatedHu !== null) {
        setMessageHu(translatedHu)
      }
    }
  }
}, [formData?.message, formData?.translated_values?.en?.message, formData?.translated_values?.hu?.message, props?.i18n?.language])

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/help-badge-type",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setTypes(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/help-badge-position",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setPositions(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/help-badge-level",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setLevels(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/help-badge-box",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        let _boxes = []
        if (response.data && response.data.data) {
          response.data.data.map((box, index) => {
            _boxes.push({
              name: box,
              key: box
            })
          })
        }
        setBoxes(_boxes);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (window.App.state.propsHelp && window.App.state.propsHelp.id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/help-badge/" + window.App.state.propsHelp.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data.data.url) {
            Fields(response.data.data.url)
          }
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  const normalizedType = (formData?.type || '').toString().toLowerCase();
  const showUrl = ['GLOBAL', 'ON_SITE', 'ON_EDIT_BOX', 'ON_SHOW_BOX', 'ON_FIELD', 'PANEL_OR_SECTION'].includes(formData.type)
    || normalizedType === 'tab'
    || normalizedType === 'section';
  const showFormField = formData.type === 'ON_FIELD';
  const showPosition = formData.type === 'ON_SITE';
  const showPanelNumber = formData.type === 'PANEL_OR_SECTION';
  const showTabNumber = normalizedType === 'tab' || normalizedType === 'section';
  const showSectionNumber = normalizedType === 'section';

  const getNumericValue = (value) => {
    if (value === undefined || value === null) {
      return '';
    }
    return value.toString().replace(/\D/g, '');
  };

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('help_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
                    <span>
                      <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                    </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            window.App.setState({
                              sidebarHelpForm: false,
                            })
                          }}
                          className="p-button-secondary p-ml-2">
                  </Button>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12"}>
                  <Field name="messageHu" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="messageHu"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('messageHu')}</label>
                      <span className="p-d-block">
                      <InputText id="messageHu" {...input}
                                 onChange={(e) => {
                                   setMessageHu(e.target.value)
                                 }}
                                 value={messageHu}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12"}>
                  <Field name="messageEn" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="message"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('messageEn')}</label>
                      <span className="p-d-block">
                      <InputText id="messageEn" {...input}
                                 onChange={(e) => {
                                   setMessageEn(e.target.value)
                                 }}
                                 value={messageEn}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="type" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="type"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('type')}</label>
                      <span className="p-d-block">
                      <Dropdown  options={types}
                                filter
                                optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                optionValue="value"
                                id={"type"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  const nextType = e.value;
                                  setFormData({
                                    ...formData,
                                    type: nextType,
                                    form_field: null,
                                    box: null,
                                    position: nextType === 'ON_SITE' ? 'TOP_OF_THE_PAGE' : null,
                                    panelNumber: null,
                                    tab_number: null,
                                    section_number: null,
                                    context: null,
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    type: nextType,
                                    form_field: null,
                                    box: null,
                                    position: nextType === 'ON_SITE' ? 'TOP_OF_THE_PAGE' : null,
                                    panelNumber: null,
                                    tab_number: null,
                                    section_number: null,
                                    context: null,
                                  })
                                }}
                                value={formData.type}
                      />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="level" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="level"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('level')}</label>
                      <span className="p-d-block">
                    <Dropdown  options={levels}
                              optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                              optionValue="value"
                              filter
                              id={"level"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  level: e.value
                                })
                                setNewFormData({
                                  ...newFormData,
                                  level: e.value
                                })
                              }}
                              value={formData.level}
                    />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {showUrl &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="url" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="url"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('url')}</label>
                        <span className="p-d-block">
                        <InputText id="url" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       url: e.target.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       url: e.target.value
                                     })
                                   }}
                                   onBlur={(e) => {
                                     Fields(e.target.value)
                                   }}
                                   value={formData.url}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {showFormField &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="form_field" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="form_field"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('form_field')}</label>
                        <span className="p-d-block">
                    <Dropdown  options={fields}
                              optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                              optionValue="key"
                              filter
                              editable
                              id={"form_field"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  form_field: e.value
                                })
                                setNewFormData({
                                  ...newFormData,
                                  form_field: e.value
                                })
                              }}
                              value={formData.form_field}
                    />
                    </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {showPosition &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="position" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="position"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('position')}</label>
                        <span className="p-d-block">
                      <Dropdown  options={positions}
                                optionLabel={(option) => window.App.getTranslatedLabel(option.key)}
                                optionValue="value"
                                filter
                                id={"position"}
                                emptyMessage={t('empty_message')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    position: e.value
                                  })
                                  setNewFormData({
                                    ...newFormData,
                                    position: e.value
                                  })
                                }}
                                value={formData.type === 'ON_SITE' ? (formData.position || 'TOP_OF_THE_PAGE') : formData.position}
                      />
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {showPanelNumber &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="panelNumber" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="panelNumber"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('panel_number')}</label>
                        <span className="p-d-block">
                        <InputText id="panelNumber" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       panelNumber: e.target.value
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       panelNumber: e.target.value
                                     })
                                   }}
                                   value={formData.panelNumber}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {showTabNumber &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="tab_number" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="tab_number"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('tab_number')}</label>
                        <span className="p-d-block">
                        <InputText id="tab_number" {...input}
                                   keyfilter="int"
                                   onChange={(e) => {
                                     const numericValue = getNumericValue(e.target.value);
                                     setFormData({
                                       ...formData,
                                       tab_number: numericValue
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       tab_number: numericValue
                                     })
                                   }}
                                   value={getNumericValue(formData.tab_number)}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
                {showSectionNumber &&
                  <div className={"p-col-12 p-lg-4"}>
                    <Field name="section_number" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="section_number"
                               className={classNames({'p-error': isFormFieldValid(meta)})}>{t('section_number')}</label>
                        <span className="p-d-block">
                        <InputText id="section_number" {...input}
                                   keyfilter="int"
                                   onChange={(e) => {
                                     const numericValue = getNumericValue(e.target.value);
                                     setFormData({
                                       ...formData,
                                       section_number: numericValue
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       section_number: numericValue
                                     })
                                   }}
                                   value={getNumericValue(formData.section_number)}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                }
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(HelpFormComponent);
